enum TruststoreDialogFields {
	TYPE = "type",
	FILE = "file",
	PASSWORD = "password"
}

export default TruststoreDialogFields;